/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ButtonConfirmPopUp from 'components/Common/Buttons/ButtonConfirmPopUp';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

import UserRoomViewContainer from './../../../containers/UserRoomViewContainer';
import MediumPreLoader from '../../../../Common/PreLoaders/MediumPreLoader';
import Messages from './RoomMessages';
import RoomSendMessageForm from './RoomSendMessageForm';

class RoomMainBlock extends Component {
  render() {
    if (!this.props.room) {
      return <MediumPreLoader />;
    }
    return (
      <div className="panel panel-default panel-heading_padding-large panel-footer_padding-large">
        <div className="panel-heading">
          <div className="full-width media">
            <div className="media-left media-middle text-overflow">
              <span className="panel-title">
                <Link to={`/main/messenger/rooms`}>
                  <i className="fa fa-arrow-circle-left" /> {t('Назад')}
                </Link>
              </span>
            </div>
            <div className="full-width media-body media-middle text-center text-o">
              {this.props.room.roomType === 1 ? (
                <Link
                  className="panel-title"
                  to={`/users/profile/${this.props.room.privateUserId}`}
                >
                  {this.props.room.roomName}
                </Link>
              ) : (
                <span className="panel-title">{this.props.room.roomName}</span>
              )}
            </div>
            {this.props.room.roomType === 2 ? (
              <div className="media-right media-middle text-overflow">
                <ButtonConfirmPopUp
                  id={'leaveFromGroupRoomConfirm'}
                  handleConfirmSuccess={() => {
                    this.props.leaveFromGroupRoom();
                    this.props.messengerMyRoomsRefresh();
                    this.props.history.push(`/main/messenger/rooms`);
                  }}
                  confirmText={t('Вы уверены что хотите покинуть группу? Вы больше не сможете читать и писть сообщения в ней.')}
                  buttonSuccessTitle={t('Выйти')}
                  aStyles={{color: '#333'}}
                >
                  <span
                    className="panel-title"
                    data-toggle="tooltip"
                    data-placement="top"
                    data-container="body"
                    title={t('Выйти из группы')}
                  >
                    <i className="fa fa-sign-out" />
                  </span>
                </ButtonConfirmPopUp>
              </div>
            ) : null}
            <div className="media-right media-middle text-overflow">
              {this.props.room.roomType === 1 ? (
                <Link
                  className="panel-title"
                  to={`/users/profile/${this.props.room.privateUserId}`}
                >
                  <img
                    alt=""
                    className="avatar avatar-xs"
                    src={this.props.room.picture}
                  />
                </Link>
              ) : (
                <img
                  alt=""
                  className="avatar avatar-xs"
                  src={this.props.room.picture}
                />
              )}
            </div>
          </div>
        </div>
        <Messages {...this.props} />
        <RoomSendMessageForm {...this.props} />
      </div>
    );
  }
}

RoomMainBlock.defaultProps = {
  room: null,
  roomRequestState: null
};

RoomMainBlock.propTypes = {
  // CONNECT STATES
  room: PropTypes.shape({
    id: PropTypes.number.isRequired,
    roomType: PropTypes.number.isRequired,
    privateUserId: PropTypes.number,
    picture: PropTypes.string.isRequired,
    roomName: PropTypes.string.isRequired,
    createdAtFormatted: PropTypes.string.isRequired,
    shortLastMessage: PropTypes.string,
    roomUuid: PropTypes.string.isRequired
  }),
  roomRequestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }),
  leaveFromGroupRoom: PropTypes.func.isRequired,
  messengerMyRoomsRefresh: PropTypes.func.isRequired
};

export default UserRoomViewContainer(withRouter(RoomMainBlock));



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/RoomMainBlock.js